export { default } from './BibBriefInfo';



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfListItem/BibBriefInfo/index.js